import { createSelector } from 'reselect';

import { isStandalone } from '../configuration/selectors';
import { hasPropertyUrlFromQuery } from './selectors';

export const isClosable = createSelector(
    isStandalone,
    hasPropertyUrlFromQuery,
    (standalone, hasPropertyUrl) => !standalone || hasPropertyUrl
);
